import React, { useState } from 'react';
import ServerFileBrowserDialog from '../DataDefinition/ServerFileBrowserDialog';
import { useTranslation } from 'react-i18next';

/**
 * 파일 경로 입력 위젯 — 직접 입력 + "찾아보기" 로 서버 디렉토리(백엔드 SAM_BROWSE_ROOT)의 파일을 골라 넣는다.
 * SAM파일 노드의 File Path, CSV 추출/적재의 sourcePath/targetPath 에 사용.
 * 선택 결과는 루트 기준 상대경로이며, 변환기(canvas_converter._csv_path)가 Airflow 의 samples 폴더 아래로 해석한다.
 */
export interface FilePathWidgetProps {
  id: string;
  value?: string;
  onChange: (v: string | undefined) => void;
  disabled?: boolean;
  readonly?: boolean;
  placeholder?: string;
}

const FilePathWidget: React.FC<FilePathWidgetProps> = ({ id, value, onChange, disabled, readonly, placeholder }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <div className="flex items-center gap-1.5">
      <input
        id={id}
        type="text"
        className="flex-1 min-w-0 rounded border border-gray-300 bg-white px-2 py-1 text-sm"
        value={value ?? ''}
        placeholder={placeholder || t('property:fp.placeholder')}
        disabled={disabled || readonly}
        onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value)}
      />
      <button
        type="button"
        className="shrink-0 px-2 py-1 text-sm rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 disabled:opacity-50"
        onClick={() => setOpen(true)}
        disabled={disabled || readonly}
        title={t('property:fp.browseTitle')}
      >
        {t('property:fp.browse')}
      </button>
      {open && (
        <ServerFileBrowserDialog
          onSelect={(relPath) => { onChange(relPath); setOpen(false); }}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default FilePathWidget;
